export default function ({ app, redirect, route }) {
  if (!app.$auth.loggedIn) {
    const fullPath = route.fullPath;
    return redirect(`/log-in?redirect=${fullPath}`);
  }
}
